import React from 'react';

const QuizType = () => {
  return <div>Pending</div>;
};

export default QuizType;
